import { useEffect, useState } from "react";

export function useBranding() {
    const [branding, setBranding] = useState(null);
    const [brandingLoading, setBrandingLoading] = useState(true);

    useEffect(() => {
        let alive = true;

        (async () => {
            try {
                const r = await fetch("/api/azienda_branding.php", { credentials: "include" });
                const j = await r.json();
                if (alive && j.success) setBranding(j.branding);
            } finally {
                if (alive) setBrandingLoading(false);
            }
        })();

        return () => { alive = false; };
    }, []);

    return { branding, brandingLoading };
}
